export default __webpack_public_path__ + "static/media/slider_image_02-sm@1x.96946aa9.webp";